import React from 'react';
import { renderField } from './DynamicForm';

// Discriminator Field - renders different fields based on discriminator value
export const DiscriminatorField = ({ field, value, onChange, error, parentFormData }) => {
  // Get the discriminator value from parent form (e.g., 'game' field determines 'configuration' shape)
  // You might need to pass additional context to determine which discriminator to use
  const discriminatorValue = value?.gameType || '';
  
  const handleFieldChange = (fieldName, fieldValue) => {
    onChange({
      ...value,
      [fieldName]: fieldValue
    });
  };

  const handleDiscriminatorChange = (newDiscriminatorValue) => {
    // When discriminator changes, reset the configuration to base schema + new discriminator defaults
    const baseDefaults = {};
    Object.entries(field.baseSchema).forEach(([key, fieldDef]) => {
      if (fieldDef.default !== undefined) {
        baseDefaults[key] = fieldDef.default;
      }
    });

    const discriminatorDefaults = {};
    if (newDiscriminatorValue && field.discriminators[newDiscriminatorValue]) {
      Object.entries(field.discriminators[newDiscriminatorValue]).forEach(([key, fieldDef]) => {
        if (fieldDef.default !== undefined) {
          discriminatorDefaults[key] = fieldDef.default;
        }
      });
    }

    onChange({
      gameType: newDiscriminatorValue,
      ...baseDefaults,
      ...discriminatorDefaults
    });
  };

  // Get available discriminator options
  const discriminatorOptions = Object.keys(field.discriminators);

  return (
    <div className="discriminator-field">
      <h3>{field.label}</h3>
      
      {/* Discriminator selector */}
      <div className="form-field">
        <label>
          {field.discriminatorKey} <span className="required">*</span>
        </label>
        <select
          value={discriminatorValue}
          onChange={(e) => handleDiscriminatorChange(e.target.value)}
          required
        >
          <option value="">-- Select Type --</option>
          {discriminatorOptions.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>

      {/* Base schema fields - always shown */}
      <div className="base-schema-fields">
        <h4>Base Configuration</h4>
        {Object.entries(field.baseSchema).map(([fieldName, fieldDef]) => (
          <div key={fieldName}>
            {renderField(fieldName, fieldDef, value?.[fieldName], (val) => handleFieldChange(fieldName, val))}
          </div>
        ))}
      </div>

      {/* Discriminator-specific fields - shown based on selection */}
      {discriminatorValue && field.discriminators[discriminatorValue] && (
        <div className="discriminator-specific-fields">
          <h4>{discriminatorValue} Configuration</h4>
          {Object.entries(field.discriminators[discriminatorValue]).map(([fieldName, fieldDef]) => (
            <div key={fieldName}>
              {renderField(fieldName, fieldDef, value?.[fieldName], (val) => handleFieldChange(fieldName, val))}
            </div>
          ))}
        </div>
      )}

      {error && <span className="error-message">{error}</span>}
    </div>
  );
};
